"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var variableMenuItems = {
  'recipientAttributes': {
    label: 'RECIPIENT ATTRIBUTES',
    group: 'variables_group'
  },
  'variableUsername': {
    label: 'User name',
    group: 'variables_group',
    command: 'variable',
    order: 1
  }
};
var variablePlugin = {
  init: function init(editor) {
    editor.addMenuGroup('variables_group');
    editor.addMenuItems(variableMenuItems);
    editor.ui.add('Variable', 'menubutton', {
      label: 'Insert Attribute',
      modes: {
        wysiwyg: 1
      },
      panel: {
        css: window.CKEDITOR.config.contentsCss
      },
      icon: 'variable',
      onMenu: function onMenu() {
        return variableMenuItems;
      }
    });
    editor.addCommand('variable', {
      editorFocus: 1,
      exec: function exec(editor, data) {
        editor.insertHtml('<input-variable type="username">username</input-variable>&nbsp;');
      }
    });
    editor.widgets.add('variable-widget', {
      upcast: function upcast(elem) {
        return elem.name === 'input-variable';
      },
      inline: true
    });
  }
};
var _default = variablePlugin;
exports.default = _default;